import { render, staticRenderFns } from "./KLabel.vue?vue&type=template&id=fc568f9a&scoped=true&"
import script from "./KLabel.vue?vue&type=script&lang=js&"
export * from "./KLabel.vue?vue&type=script&lang=js&"
import style0 from "./KLabel.vue?vue&type=style&index=0&id=fc568f9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc568f9a",
  null
  
)

export default component.exports